// extracted by mini-css-extract-plugin
export default {"covered":"table_covered__Np5q2","not_covered":"table_not_covered__AURQD"};